// Utility to decode JWT and check expiration
// No external dependencies

function decodePayload(token: string): any | null {
  try {
    const payload = token.split('.')[1];
    if (!payload) return null;
    // atob works in browsers
    const decoded = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
    return JSON.parse(decodeURIComponent(escape(decoded)));
  } catch (e) {
    return null;
  }
}

export function isTokenValid(token: string | null): boolean {
  if (!token) return false;
  const payload = decodePayload(token);
  if (!payload || !payload.exp) return false;
  // exp is seconds since epoch
  const now = Math.floor(Date.now() / 1000);
  return payload.exp > now;
}

export function getTokenExpiration(token: string | null): number | null {
  const payload = decodePayload(token || '');
  return payload && payload.exp ? payload.exp : null;
}
